import { render, staticRenderFns } from "./RunnitBoard.vue?vue&type=template&id=5aa18928&scoped=true"
import script from "./RunnitBoard.vue?vue&type=script&lang=ts"
export * from "./RunnitBoard.vue?vue&type=script&lang=ts"
import style0 from "./RunnitBoard.vue?vue&type=style&index=0&id=5aa18928&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa18928",
  null
  
)

export default component.exports